export default function getDimensions(widthOrHeight) {
  if (typeof widthOrHeight === 'number') {
    return `${widthOrHeight}px`;
  } return widthOrHeight;
}
